module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/starEmpty-896e384b9f40037a303d44bf54e22836.png";